import React from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import Logo from "./Logo"
import { Container } from "react-bootstrap"

const github_url = "https://github.com/debajitdeb11"
const github_description = "Github"

const linkedin_url = "https://www.linkedin.com/in/debajitdeb11/"
const linkedin_description = "Linkedin"

// const facebook_url = "https://www.facebook.com/knowdebajit/"
// const facebook_description = "Facebook"

const instagram_url = "https://www.instagram.com/debajitdeb11/"
const instagram_description = "Instagram"

export default function () {
  return (
    <div
      style={{
        margin: 10,
      }}
    >
      {/* <Container className="text-center center-block">
        <Row className="justify-content-sm-center">
          <Col>
            <Logo
              imageSrc={require("../images/github.png")}
              url={github_url}
              description={github_description}
            />
          </Col>
          <Col>
            <Logo
              imageSrc={require("../images/linkedin.png")}
              url={linkedin_url}
              description={linkedin_description}
            />
          </Col>
          <Col>
            <Logo
              imageSrc={require("../images/facebook.png")}
              url={facebook_url}
              description={facebook_description}
            />
          </Col>
          <Col>
            <Logo
              imageSrc={require("../images/instagram.png")}
              url={instagram_url}
              description={instagram_description}
            />
          </Col>
          <Col>
            <Logo
              imageSrc={require("../images/email.png")}
              url="mailto:debajitdeb11@gmail.com"
            />
          </Col>
        </Row> */}

      <Container className="d-flex justify-content-center">
        <div className="p-2">
          <Logo
            imageSrc={require("../images/github.png")}
            url={github_url}
            description={github_description}
          />
        </div>
        <div className="p-2">
          <Logo
            imageSrc={require("../images/linkedin.png")}
            url={linkedin_url}
            description={linkedin_description}
          />
        </div>
        {/* <div className="p-2">
          <Logo
            imageSrc={require("../images/facebook.png")}
            url={facebook_url}
            description={facebook_description}
          />
        </div> */}
        <div className="p-2">
          <Logo
            imageSrc={require("../images/instagram.png")}
            url={instagram_url}
            description={instagram_description}
          />
        </div>
        <div className="p-2">
          <Logo
            imageSrc={require("../images/email.png")}
            url="mailto:debajitdeb11@gmail.com"
            description="email"
          />
        </div>
      </Container>

      <p
        className="text-muted"
        style={{
          textAlign: "center",
          paddingTop: 15,
        }}
      >
        Debajit Deb &copy;
      </p>
      {/* </Container> */}
    </div>

    // <div>
    //   <Row className="justify-content-md-center">
    //     <Col xs lg="1">
    //       <Logo
    //         imageSrc={require("../images/github.png")}
    //         url={github_url}
    //         description={github_description}
    //       />
    //     </Col>
    //     <Col xs lg="1">
    //       <Logo
    //         imageSrc={require("../images/linkedin.png")}
    //         url={linkedin_url}
    //         description={linkedin_description}
    //       />
    //     </Col>
    //     <Col xs lg="1">
    //       <Logo
    //         imageSrc={require("../images/facebook.png")}
    //         url={facebook_url}
    //         description={facebook_description}
    //       />
    //     </Col>
    //     <Col xs lg="1">
    //       <Logo
    //         imageSrc={require("../images/instagram.png")}
    //         url={instagram_url}
    //         description={instagram_description}
    //       />
    //     </Col>
    //   </Row>
    //   <p
    //     style={{
    //       textAlign: "center",
    //       paddingTop: 15,
    //     }}
    //   >
    //     Debajit Deb &copy;
    //   </p>
    // </div>
  )
}
